import React, { Component } from 'react'
// import InputBox from '../usefulcomps/InputBox'
export default class Thousandfour extends Component {
    constructor(props){
        super(props)
        this.state = {
            isUpdationDone:false
        }
        this.storeMonth = this.storeMonth.bind(this)
        this.getDate = this.getDate.bind(this)
    }
    getDate = (e) => {
        var defStr = e
        var arr = defStr.split(' ')[0].split('-')
        return arr[0]+'-'+arr[1]
    }
    componentDidMount(){
        console.log("ComponentDidMount")
        this.setState({
            date:this.getDate(this.props.defdata),
            isUpdationDone:true
        })
    }
    componentDidUpdate(prevProps){
        console.log("componentDidUpdate")
        if (prevProps.defdata != this.props.defdata) {
            this.setState({isUpdationDone:false})
            console.log(this.props.defdata)
            var test = this.getDate(this.props.defdata);
            this.setState({
                date: this.getDate(test),
                isUpdationDone:true
            })
        }
    }
    storeMonth(e){
        if(e.target.value != ""){
            console.log(new Date)
            var todayDate = new Date()
            if(todayDate.getDate() > 10){
                var date = e.target.value+'-'+todayDate.getDate()+' 00:00:00.000'
                this.props.onChange(date)
            }else{
                var date = e.target.value+'-0'+todayDate.getDate()+' 00:00:00.000'
                this.props.onChange(date)
            }
        }
        this.setState({date:e.target.value})
    }
    render() {
        const style={
            border:"none",
            background:'none',
            paddingLeft:'0px',
            marginBottom:'15px'
        }
        return (
            <>
            {
                this.state.isUpdationDone?
                <div className='form-group' style={{paddingBottom:"10px"}}>
                    <label htmlFor='monthyear' style={{fontWeight:'600',fontSize:'18px'}}>Select Month</label>
                    <input style={style} type="month" id='monthyear' value={this.state.date} className='form-control' onChange={(e) => this.storeMonth(e)}/>
                </div>
                :
                "loading"
            }
                
            </>
        )
    }
}
